import { storageHelper } from './storageHelper';

export const authStorage = {
    getInitialState: () => (
        {
            isAuthenticated: !!storageHelper.get('token'),
            token: storageHelper.get('token'),
            units: JSON.parse(sessionStorage.getItem('units')) || [],
            activeUnit: JSON.parse(sessionStorage.getItem('activeUnit')) || null,
            signedEula: storageHelper.get('signedEula') === true,
            isFirstLogin: storageHelper.get('isFirstLogin') === true
        }
    ),

    updateStorage: (updates) => {
        Object.entries(updates).forEach(([key, value]) => {
            storageHelper.set(key, value);
        });
    }
};
